<nz-tabset nzCentered nzSize="large" [(nzSelectedIndex)]="tabIndex">
    <nz-tab [nzTitle]="tab.title" *ngFor="let tab of tabIndexList; let i = index" [nzDisabled]="isLoading" >
        <ng-template nz-tab>
            <div nz-row nzJustify="center">
                <div nz-col class="text-center" nzSpan="6">
                </div>
                <div nz-col class="text-center" nzSpan="12">
                    <nz-input-group [nzSuffix]="suffixIconSearch" style="width: clamp(200px, 75%, 400px);">
                        <input type="text" nz-input [(ngModel)]="inputValue" placeholder="Advanced Filter" style="text-transform:uppercase;" />
                    </nz-input-group>
                    <ng-template #suffixIconSearch>
                        <span nz-icon nzType="search"></span>
                    </ng-template>
                </div>
                <div nz-col class="text-center" nzSpan="6">
                    <span *ngIf="tab.index === 0">Remove Pin Verification:</span><nz-switch style="margin-left: 8px;" [(ngModel)]="isVerificationRemover" *ngIf="tab.index === 0"></nz-switch>
                    <button nz-button nzType="primary" (click)="removePinVerification()" [disabled]="!allChecked() && !indeterminate() && !isVerificationRemover" style="margin-left: 8px;" *ngIf="tab.index === 0">Remove</button>
                </div>
            </div>
            <br>
            <nz-table #stockTable [nzData]="filterSafeGoList(tab.index)" [nzFrontPagination]="false" [nzLoading]="isLoading">
                <thead>
                    <tr>
                        <th>Customer</th>
                        <th>Vehicle</th>
                        <th>Salesman</th>
                        <th>Order Number</th>
                        <th>
                            Order Date
                            <nz-range-picker
                                nzAllowClear
                                nzFormat="EEE MMM dd yyyy"
                                [(ngModel)]="selectedOrderDateRange"
                                style="width: 270px; margin-left: 8px;"
                            ></nz-range-picker>
                        </th>
                        <th>Order Status</th>
                        <th *ngIf="tab.index === 0">
                            <label
                                *ngIf="isVerificationRemover"
                                nz-checkbox
                                [ngModel]="allChecked()"
                                (ngModelChange)="onAllCheckedChange($event)"
                                [nzIndeterminate]="indeterminate()"
                                >
                                Check all
                            </label>
    </th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of stockTable.data | filter: inputValue: []: 0: pageSize;">
                        <td>{{ item.customerName }}</td>
                        <td>{{ item.vehicleMake }} | {{item.vehicleModel}} | {{ item.vehicleReg}}</td>
                        <td>{{ item.salesMan }}</td>
                        <td>{{ item.orderRef }}</td>
                        <td>{{ item.date + 'Z' | date: 'medium'}}</td>
                        <td *ngIf="item.safeGoStatus === 0" class="text-center"><i nz-icon nzType="exclamation-circle" nzTheme="outline" class="color-warning" nz-tooltip="WhatsApp Not Sent"></i></td>
                        <td *ngIf="item.safeGoStatus === 1" class="text-center"><i nz-icon nzType="clock-circle" nzTheme="outline" class="color-primary" nz-tooltip="Waiting for SafeGo Verification"></i></td>
                        <td *ngIf="item.safeGoStatus === 2" class="text-center"><i nz-icon nzType="check-circle" nzTheme="outline" class="color-success" nz-tooltip="SafeGo has been Verified"></i></td>
                        <td *ngIf="item.safeGoStatus === 3" class="text-center"><i nz-icon nzType="minus-circle" nzTheme="outline" class="color-warning" nz-tooltip="SafeGo Verification has been Removed"></i></td>
                        <td *ngIf="!isVerificationRemover && tab.index === 0" class="text-center">
                            <button nz-button nzType="default" *ngIf="item.safeGoStatus === 0" (click)="sendSafeGoWhatsApp(item)">Send Pin <i nz-icon nzType="whats-app" nzTheme="outline"></i></button>
                            <button nz-button nzType="default" *ngIf="item.safeGoStatus === 1" (click)="sendSafeGoWhatsApp(item)">Resend Pin <i nz-icon nzType="whats-app" nzTheme="outline"></i></button>
                            <button nz-button nzType="primary" [disabled]="item.safeGoStatus === 0" (click)="openSafeGoModal(item)" style="margin-left: 8px;">Verify<i nz-icon nzType="check-circle" nzTheme="outline"></i></button>
                            
                        </td>
                        <td *ngIf="isVerificationRemover" class="text-center">
                            <label nz-checkbox [(ngModel)]="item.removePinVerification">Remove Verification{{item.removePinVerifcation}}</label>
                        </td>
                    </tr>
                </tbody>
            </nz-table>
        </ng-template>
    </nz-tab>
</nz-tabset>

<nz-modal [(nzVisible)]="verifySafeGoModal" nzClosable="true" nzTitle="Please Provide SafeGo Pin" (nzOnCancel)="verifySafeGoModal = false;" [nzFooter]="null">
    <ng-container *nzModalContent>
        <nz-row nzJustify="center" nzAlign="middle" nzGutter="16">
            <nz-col nzSpan="18">
                <input nz-input type="number" placeholder="Enter SafeGo Pin" [(ngModel)]="safeGoPin" />
            </nz-col>
            <nz-col nzSpan="6">
                <button nz-button nzType="primary" (click)="verifySafeGo(selectedSafeGoItem, safeGoPin)"  style="text-align: center;">Verify</button>
            </nz-col>
        </nz-row>
    </ng-container>
</nz-modal>

